import { buildScopedI18n } from '../../utils/buildScopedI18n';
import esCL from './locales/es-CL.json';
import enUS from './locales/en-US.json';
import ptBR from './locales/pt-BR.json';

export const detectionMonitoringI18n = buildScopedI18n({
  esCL,
  enUS,
  ptBR,
});
